<template>
    <div>
        <ul>
            <refund-request-details-collapsible-section
                title="Job Details"
                :list="jobDetails"
            />
            <refund-request-details-collapsible-section
                title="System Details"
                :list="systemDetails"
            />
            <refund-request-details-collapsible-section
                v-if="!isPaidByCard"
                title="Bank Details"
                :list="bankDetails"
            />
            <refund-request-details-collapsible-section
                title="Original transaction details"
                :list="originalTransactionDetails"
            />
            <refund-request-details-collapsible-section
                v-if="bpointRefundTransactions.length > 0"
                title="Refund transaction details"
            >
                <div
                    v-for="(txn, index) in bpointRefundTransactions"
                    :key="txn.id"
                >
                    <hr v-if="index !== 0">
                    <field-value-list
                        :list="txn"
                    />
                </div>
            </refund-request-details-collapsible-section>
        </ul>
    </div>
</template>

<script>

import { prettify, formatPrice, cloneObject } from  '@strangeanimals/common-vue-components/src/helpers/helpers'
const FieldValueList = () => import("./FieldValueList");
const RefundRequestDetailsCollapsibleSection = () => import("./RefundRequestDetailsCollapsibleSection");

export default {
    name: 'RefundRequestDetailsSection',
    components: { RefundRequestDetailsCollapsibleSection, FieldValueList },
    props: {
        refundRequest: {
            type: Object,
            required: true,
        }
    },
    computed: {
        refundableDetails() {
            let result = {};
            if (this.refundRequest) {
                result = this.refundRequest['refundable_details'];
            }
            return result;
        },
        jobDetails() {
            let jobDetails = {};
            let jobDetailsFields = [
                'job_number',
                'salesforce_account_title',
                'buyer_name',
                'buyer_email',
                'cancellation_reason',
                'consultant',
                'manager',
                'site_lot_number',
                'site_street_number',
                'site_street_name',
                'site_suburb',
                'site_state',
                'site_postcode',
            ];

            let refundRequestFields = {
                'salesforce_account_title': 'brand'
            };

            let fieldsToShowWithId = {
                'consultant': 'consultant_id',
                'manager': 'manager_id',
            };

            jobDetailsFields.forEach((value) => {
                if (refundRequestFields.hasOwnProperty(value)) {
                    jobDetails[refundRequestFields[value]] = this.refundRequest[value];
                } else if (fieldsToShowWithId.hasOwnProperty(value)) {
                    if (this.refundableDetails[value]) {
                        jobDetails[value] = this.refundableDetails[value] + " (" + this.refundableDetails[fieldsToShowWithId[value]] + ")";
                    } else {
                        jobDetails[value] = 'N/A';
                    }
                } else {
                    jobDetails[value] = this.refundableDetails[value];
                }
            });

            return jobDetails;
        },
        systemDetails() {
            let systemDetails = {};

            let systemDetailsFields = [
                'updated_framework_date',
                'updated_salesforce_date',
                'latest_framework_error',
                'latest_framework_error_date',
                'latest_bpoint_error',
                'latest_bpoint_error_date',
            ];

            systemDetailsFields.forEach((value) => {
                if (this.refundRequest[value] || value.includes('date')) {
                    systemDetails[value] = this.refundRequest[value];
                } else {
                    systemDetails[value] = 'N/A';
                }
            });

            return systemDetails;
        },
        originalTransactionDetails() {
            let originalTransactionDetails = {};

            let originalTransactionDetailsFields = [
                'amount',
                'bpoint_receipt_number',
                'salesforce_receipt_number',
                'transaction_number',
                'salesforce_id',
                'retrieval_reference_number',
                'card_type',
                'authorise_id'
            ];

            originalTransactionDetailsFields.forEach((value) => {
                originalTransactionDetails[value] = this.refundableDetails[value];
            });

            return originalTransactionDetails;
        },
        bankDetails() {
            let result = {};

            let fields = [
                'account_name',
                'bsb',
                'account_number',
            ];

            fields.forEach((value) => {
                result[value] = this.refundRequest[value];
            });

            return result;
        },
        bpointRefundTransactions() {
            let refundTransactions = [];
            if (this.refundRequest) {
                let bpointRefundTransactions = cloneObject(this.refundRequest['bpoint_refund_transactions']);

                let refundTransactionDetailsFields = [
                    'amount_original',
                    'amount_surcharge',
                    'receipt_number',
                    'original_txn_number',
                    'txn_number',
                    'card_type',
                    'authorise_id',
                    'processed_date_time'
                ];

                let fieldsToRename = {
                    'original_txn_number' : 'original transaction number',
                    'txn_number' : 'transaction number'
                };

                bpointRefundTransactions.forEach((txn) => {
                    let refundTransaction = {};

                    refundTransactionDetailsFields.forEach((value) => {
                        if (fieldsToRename.hasOwnProperty(value)) {
                            refundTransaction[fieldsToRename[value]] = txn[value];
                        } else {
                            refundTransaction[value] = txn[value];
                        }
                    });

                    refundTransactions.push(refundTransaction);

                });


            }
            return refundTransactions;
        },
        isPaidByCard() {
            return this.refundRequest && this.refundRequest.payment_method.includes('Card');
        }
    },
    methods: {
        prettify(word) {
            return prettify(word);
        },
        formatPrice(price) {
            return formatPrice(price);
        }
    }
}
</script>

<style>
    ul {
        list-style: none;
        padding: 0px;
    }
</style>
